// This file is modified during CI builds. Do not change this
// file unless you know what you are doing
const APPLICATION_VERSION = "v1.455.98-TSS-3104-mcastro-Campaign-builder-lag-on-C70005-Get-Fire-Ready-multiple-users.0";

export const getApplicationVersion = (): string => APPLICATION_VERSION;
